import { setSearchParams } from './urlUtils';
import userIntents from '../userIntents.js';

const { RENT, BUY, SELL, LET } = userIntents;

export function getUserIntentUpdater(store, defaultUserIntent) {
  const userIntentRegex = new RegExp(`.*[?&]userIntent=(${RENT}|${BUY}|${SELL}|${LET}).*`);
  let prevUserIntent = store.getState().userIntent;

  function updateUserIntentInQueryString() {
    const userIntent = store.getState().userIntent || defaultUserIntent;

    const { history, location } = window;
    if (history && history.pushState && userIntent !== prevUserIntent) {
      const { pathname, search, hash } = location;
      // TODO: think of simplifying this with `String.contains`
      const userIntentInQuery = (userIntentRegex.exec(search) || [])[1];
      if (!userIntentInQuery && userIntent === defaultUserIntent) return;

      const newSearch = setSearchParams('userIntent', userIntent);
      history.pushState(null, '', pathname + newSearch + hash);
      prevUserIntent = userIntent;
    }
  }

  return updateUserIntentInQueryString;
}

export default { getUserIntentUpdater };
